import { Auth } from '@nackle/bridge';
import { idURL } from 'endpoints';
import { applyRequestMiddleware } from './utils/fetch';

const auth = new Auth( {
    authority: idURL
} );

export default auth;

applyRequestMiddleware( function( url, options ) {
    options.headers = {
        ...( options.headers || {} ),
        'company-id': auth.state.claims.company_id,
        'x-company-id': auth.state.claims.company_id,
    };

    if ( auth.state.access_token ) {
        options.headers.authorization = `Bearer ${ auth.state.access_token }`;
    }
 } );
